import { Sparkles, Wrench } from 'lucide-react';
import styles from './CreateNewToolModal.module.css';

interface CreateNewToolModalProps {
  open: boolean;
  onCreateManually: () => void;
  onBuildWithAi: () => void;
  onClose: () => void;
}

export default function CreateNewToolModal({ open, onCreateManually, onBuildWithAi, onClose }: CreateNewToolModalProps) {
  if (!open) return null;

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={e => e.stopPropagation()}>
        <h2 className={styles.title}>Create New Tool</h2>
        <p className={styles.subtitle}>How would you like to create this tool?</p>
        <div className={styles.options}>
          <button className={styles.optionCard} onClick={onCreateManually}>
            <Wrench size={28} className={styles.optionIcon} />
            <span className={styles.optionLabel}>Create Manually</span>
            <span className={styles.optionDesc}>Fill in the wizard step by step</span>
          </button>
          <button className={`${styles.optionCard} ${styles.optionCardAi}`} onClick={onBuildWithAi}>
            <Sparkles size={28} className={`${styles.optionIcon} ${styles.optionIconAi}`} color="#f9e77e"/>
            <span className={styles.optionLabel}>Build with AI</span>
            <span className={styles.optionDesc}>Describe your tool in chat, AI populates the form</span>
          </button>
        </div>
      </div>
    </div>
  );
}
